import {
  createFileRoute,
  Outlet,
  useLocation,
  useNavigate
} from '@tanstack/react-router';
import { Button, Modal, Tabs, TabsProps } from 'antd';
import * as React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { PlusSignIcon, StarFreeIcons, User02Icon } from '@hugeicons/core-free-icons';
import { IconPlus } from '@tabler/icons-react';
import Loader from '../../../../components/Loader';
import CustomersGroupSelectTemplates from '../../../../components/customers/CustomersGroupSelectTemplates';
import { useState } from 'react';
import PageLoader from '../../../../microcomponents/PageLoader';
import { NButton } from '@next-is-free-monorepo/nif-web-components';
import PlanGate from '../../../../components/PlanGate';

export const Route = createFileRoute(
  '/_authenticated/customers/_customersLayout'
)({
  component: RouteComponent,
  pendingComponent: ()=> <PageLoader/>
});

const tabs: TabsProps['items'] = [
  {
    key: 'all',
    label: 'Clienti',
    children: (
      <div className={'mb-20'}>
        <Outlet />
      </div>
    )
    /*    icon: <HugeiconsIcon icon={User02Icon} className={'inline-block'} size={12} strokeWidth={1.5} />*/
  },
  {
    key: 'groups',
    label: 'Gruppi',
    children: (
      <div className={'mb-20'}>
        <Outlet />
      </div>
    )
    /*    icon: <HugeiconsIcon icon={Megaphone03FreeIcons} className={'inline-block'} size={12} strokeWidth={1.5}/>*/
  }
];

function RouteComponent() {
  const navigate = useNavigate();
  const location = useLocation();


  const [newGroupModalOpen, setNewGroupModalOpen] = useState(false);

  return (
    <div className={'p-4'}>
      <div className={'flex items-center justify-between'}>
        {location.pathname === '/customers'
          ? <>
            <h1 className={'font-bold text-xl mb-4'}>Clienti</h1>
        {/*    <Button type={'primary'}>Invita</Button>*/}
          </>
          : <>
            <h1 className={'font-bold text-xl mb-4'}>Gruppi</h1>
            <div>
              <PlanGate featureKey={'accessCustomers'} hideMask>
                <NButton color={'secondary'} size={'small'} hugeIcon={PlusSignIcon} onClick={()=>setNewGroupModalOpen(true)}>Nuovo</NButton>
              </PlanGate>
            </div>
          </>}

      </div>
      <Tabs
        activeKey={
          location.pathname === '/customers'
            ? 'all'
            : location.pathname.split('/').pop()
        }
        onChange={(selected: string) => {
          navigate({
            to: selected === 'all' ? '/customers' : '/customers/' + selected
          });
        }}
        items={tabs}
      />
      <Modal open={newGroupModalOpen} destroyOnHidden onCancel={()=>setNewGroupModalOpen(false)} footer={<></>}>
        <CustomersGroupSelectTemplates/>
      </Modal>
    </div>
  );
}
